import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
//import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import rootReducer from './Comman/rootReducer'
import './i18n';


import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css'

const middleware = [thunk]

export const rootStore = createStore(rootReducer,
        applyMiddleware(...middleware),
);

ReactDOM.render(
    <Provider store = {rootStore}>
        <App />
    </Provider>,
    document.getElementById('root')  
);

//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
 
  
